import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { ArrowLeftIcon, LayoutIcon, CodeIcon, SmartphoneIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const TeamLid3Page: React.FC = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-2242">
      <SEO data-id="element-2243" />
      <Header data-id="element-2244" />

      <main className="pt-32 pb-20 lg:pt-40 lg:pb-24" data-id="element-2245">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2246">
          <button onClick={() => navigate('/over-ons')} className="inline-flex items-center gap-2 text-[#004AC7] font-medium hover:underline mb-12" data-id="element-2247">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-2248" /> Terug naar het team
          </button>

          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-2249">
            <div className="lg:w-1/3 flex justify-center lg:justify-start" data-id="element-2250">
              <div className="w-[300px] h-[300px] rounded-full border-4 border-[#004AC7] overflow-hidden shadow-lg" data-id="element-2251">
                <img src="https://cdn.magicpatterns.com/uploads/gwFh8VhGW156sUNRdzC2Ac/image.png" alt="Alex" className="w-full h-full object-cover" style={{
                objectPosition: 'center 35%'
              }} data-id="element-2252" />
              </div>
            </div>

            <div className="lg:w-2/3" data-id="element-2253">
              <h1 className="text-4xl md:text-5xl font-bold text-[#111827] mb-2" data-id="element-2254">
                Alex
              </h1>
              <p className="text-xl text-[#607697] font-medium mb-8" data-id="element-2255">
                Developer
              </p>

              <div className="prose prose-lg text-[#4B5563] mb-12" data-id="element-2256">
                <p className="mb-4" data-id="element-2257">
                  Als Developer bouw ik de websites en webapplicaties van Noord
                  Digital. Ik vertaal de strategische visie van CorePrint naar
                  snelle, gebruiksvriendelijke en conversiegerichte websites die
                  perfect passen bij de merkidentiteit van onze klanten.
                </p>
                <p className="mb-4" data-id="element-2258">
                  Mijn focus ligt op het creëren van naadloze
                  gebruikerservaringen (UX) en strakke interfaces (UI). Een
                  website moet er niet alleen fantastisch uitzien, maar ook
                  intuïtief werken op elk apparaat en razendsnel laden.
                </p>
                <p data-id="element-2259">
                  Ik bouw robuuste, schaalbare oplossingen in WordPress, waarbij
                  ik altijd rekening houd met de nieuwste webstandaarden,
                  toegankelijkheid en technische SEO-vereisten.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-[#111827] mb-6" data-id="element-2260">
                Expertise
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2261">
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2262">
                  <LayoutIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2263" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2264">WordPress</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2265">
                  <SmartphoneIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2266" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2267">UI/UX Design</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2268">
                  <CodeIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2269" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2270">
                    Frontend Development
                  </h3>
                </div>
              </div>

              <a href="/#contact" className="inline-block bg-[#004AC7] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#003A9E] transition-colors shadow-md" data-id="element-2271">
                Neem contact op met Alex
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2272" />
    </div>;
};